import { NotFoundIcon } from '@p2p/assets/svg';

import { ErrorPage } from './components';

export const NotFoundErrorPage = () => {
  return (
    <ErrorPage
      title="Упс! Мы не можем найти эту страницу."
      description="Страница, на которую вы перешли, не существует или была удалена."
      icon={<NotFoundIcon />}
    />
  );
};
